import api from "../lib/axios";

export const getAffiliateDashboard = async (eventId, token) => {
  const res = await api.get(`/affiliate/dashboard/${eventId}`, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
  return res;
};

export const getAllAffiliates = async (eventId, token) => {
  const res = await api.get(`/affiliate/${eventId}`, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
  return res;
};

export const createAffiliate = async (eventId, data, token) => {
  const res = await api.post(`/affiliate/${eventId}`, data, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
  return res;
};

export const updateAffiliate = async (id, data, token) => {
  const res = await api.put(`/affiliate/${id}`, data, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
  return res;
};

export const deleteAffiliate = async (id, token) => {
  const res = await api.delete(`/affiliate/${id}`, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
  return res;
};

export const addAffiliateVisit = async (username) => {
  const res = await api.post(`/affiliate/visit/${username}`);
  return res;
};
